<template>
    <div>
        <el-header class="navbg">
            <div class="contBox">
                <hq-nav/>
            </div>
        </el-header>
        <el-main class="contact">
            <div class="contBox" id="contBox">
                <h3>联系我们</h3>
                <el-divider class="fg"></el-divider>
                <el-row  :gutter="20">
                    <el-col :xl="16" :lg="18" :md="17" :sm="22">
                        <el-link :href="href" target="_blank" class="mapStyle" title="点击前往-北京和峰科技有限公司">
                            <img src="../assets/images/map.png" alt="点击前往-北京和峰科技有限公司">
                        </el-link>
                    </el-col>
                    <el-col :xl="6" :lg="6" :md="6" :sm="24">
                        <h4>北京和峰科技有限公司</h4>
                        <p class="contactText">地址：北京市昌平区生命科学园路4号院8号楼3层</p>
                        <p class="contactText">邮编：102206</p>
                        <p class="contactText p_block">
                            <span>服务电话：</span>
                            <span>16710111126  章工<br>15600003218  赵工<br>+86-10-53241135</span>
                        </p>
                        <p class="contactText">邮箱地址：marketing@harqom.com</p>
                    </el-col>
                </el-row>
            </div>
        </el-main>

        <el-footer class="footer">
            <hq-footer/>
        </el-footer>
    </div>
</template>

<script>
    import Nav from "./Nav";
    import Footer from "./Footer";
    export default {
        name: "ContactUs",
        data(){
            return {
                href:"https://map.baidu.com/poi/%E5%8C%97%E4%BA%AC%E5%92%8C%E5%B3%B0%E7%A7%91%E6%8A%80%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8/@12943739.435,4853897.26,19z?uid=0c0bd457d4779670bfa82227&ugc_type=3&ugc_ver=1&device_ratio=1&compat=1&pcevaname=pc4.1&newfrom=zhuzhan_webmap&querytype=detailConInfo&da_src=shareurl"
            }
        },
        components:{
            "hq-nav":Nav,
            "hq-footer":Footer,
        }
    }
</script>

<style scoped>
    .footer{
        position: fixed;
        bottom: 0;
        left: 0;
    }
    .contact{
        background: #000000;
        padding: 2rem 0;
        height: auto;
        overflow: hidden;
        box-sizing: border-box;
    }
    .contact h4{
        color: #ffffff;
        font-family: AlibabaPuHuiTi-Bold;
        font-size: 1.875rem;
        text-align: left;
        width: 100%;
        height: auto;
        overflow: hidden;
    }
    .contact h3{
        font-family: AlibabaPuHuiTi-Heavy;
        font-size: 3.35rem;
        color: #ffffff;
        margin: 0 0;
        text-align: left;
    }
    .mapStyle{
        width: 100%;
        height: auto;
        display: block;
    }
    .mapStyle img{
        width: 100%;
        height: 100%;
        object-fit: contain;
    }
    .contactText{
        font-family: AlibabaPuHuiTi;
        font-size: 1.125rem;
        text-align: left;
        color: #ffffff;
    }
    .contactText span:first-child{
        float: left;
    }
    .contactText span:last-child{
        float: left;
        text-align: right;
    }
    .p_block{
        overflow: hidden;
    }
</style>
